import { gql } from '@apollo/client';

export const StreamBasicFields = gql`
  fragment StreamBasicFields on Stream {
    id
    slug
    description
    name
    scheduleDate
    scheduleDateUtc
    timeZone {
      tzCode
      offset
    }
    repeatsEveryEnum
    isPurchased
    streamStatus
    imageURL
  }
`;

export const StreamFields = gql`
  fragment StreamFields on Stream {
    id
    slug
    description
    name
    scheduleDate
    scheduleDateUtc
    isInterview
    deletedAt
    type
    interview {
      id
      interviewer {
        id
        firstName
        lastName
      }
      interviewee {
        id
        firstName
        lastName
      }
      status
      streamCohostToken
    }
    hashtags {
      id
      name
    }
    timeZone {
      tzCode
      offset
    }
    sponsors {
      id
      logo
      logoUrl
      name
    }
    moderator {
      id
    }
    mentions {
      id
      mentionType
      store {
        slug
        id
        role
        storeDetails {
          storeName
        }
      }
      targetType
      unregisteredContact {
        id
        name
        representativeName
        phoneNumber
        type
        email
        name
        representativeName
        socialMediaLink
        url
      }
    }
    isPurchased
    parentStreamId
    repeatingTitle
    repeatsEvery {
      days
      hours
      milliseconds
      minutes
      months
      seconds
      years
    }
    repeatsEveryEnum
    isPPV
    streamStatus
    imageURL
    requestedPrice
    price
    isFree
    store {
      id
      slug
    }
  }
`;

export const SoonestStreamFields = gql`
  fragment SoonestStreamFields on Stream {
    id
    slug
    imageURL
    isPurchased
    store {
      id
      slug
    }
    scheduleDateUtc
    type
    streamStatus
    interview {
      id
      status
      source {
        type
      }
      interviewer {
        id
        firstName
        lastName
        avatarUrl
        storeDetails {
          id
          storeName
        }
      }
      interviewee {
        id
        firstName
        lastName
        avatarUrl
        storeDetails {
          id
          storeName
        }
      }
      streamCohostToken
      stream {
        id
        streamStatus
      }
    }
  }
`;

export const GetUpcomingStreamsEntities = gql`
  fragment GetUpcomingStreamsEntities on Stream {
    id
    slug
    name
    imageURL
    isHidden
    price
    description
    isFree
    streamStatus
    repeatingTitle
    repeatsEveryEnum
    scheduleDate
    scheduleDateUtc
    timeZone {
      tzCode
      offset
    }
    isPurchased
    type
    store {
      id
      slug
      lastName
      firstName
      storeDetails {
        id
        storeName
        avatarURL
      }
    }
  }
`;

export const StreamNoteFields = gql`
  fragment StreamNoteFields on StreamNote {
    id
    note
    relativeTs
  }
`;
